module.exports = __webpack_public_path__ + "static/media/shield-5.eb95c6a6.glb";